import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApprovalLetterTemplate } from 'src/app/models/approval-letter-template.model';
import { environment } from 'src/environments/environment';
import { UtilsInterface } from './utils.interface';
import { BroadcastMessageFormDto } from 'src/app/models/broadcast-message-form-dto';

@Injectable({ providedIn: 'root' })
export class UtilsService implements UtilsInterface {

  constructor(private httpClient: HttpClient) { }

  GetLetterTemplate(letterId: string, isFrench: boolean, courseApprovalId: string): Observable<ApprovalLetterTemplate> {
    return this.httpClient.get<ApprovalLetterTemplate>(environment.apiBaseUrl + `Util/GetLetterTemplate/${letterId}/${isFrench}/${courseApprovalId}`);
  }

  DownloadDecisionLetter(decisionTemplateId: string, isFrench: boolean, courseApprovalId: string, directorName?: string) {
    if(directorName == null) directorName = "";
    return this.httpClient.get(environment.apiBaseUrl + `Util/DownloadDecisionLetterForTP/${decisionTemplateId}/${isFrench}/${courseApprovalId}?directorName=${encodeURIComponent(directorName)}`);
  }

  PreviewDecisionLetterImages(decisionTemplateId: string, isFrench: boolean, courseApprovalId: string, directorName?: string) {
    if(directorName == null) directorName = "";
    return this.httpClient.get(environment.apiBaseUrl + `Util/PreviewDecisionLetterImagesForTP/${decisionTemplateId}/${isFrench}/${courseApprovalId}?directorName=${encodeURIComponent(directorName)}`);
  }

  GetSubstring(originalText: string | Date | number | undefined, numberOfCharacters: number, showElipsis: boolean = true) {
    let convertedText = '';
    if (!originalText) return '';
    if (typeof originalText === 'object' || typeof originalText === 'number') convertedText = originalText.toString();
    if (typeof originalText === 'string') convertedText = originalText;

    return convertedText?.slice(0, numberOfCharacters) + (((convertedText.length > numberOfCharacters) && showElipsis) ? "..." : "") || '';
  }

  GetBroadcastMessages(msg: BroadcastMessageFormDto): Observable<any> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `broadcast/GetBroadcastMessages`, msg);
  }

  GetAllFeatureFlags(): Observable<string[]> {
    return this.httpClient.get<any>(environment.apiBaseUrl + 'util/AllFeatureFlags');
  }


}
